import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, watch } from "vue";
import { EChartsOption, init } from "echarts";
import { useI18n } from "vue-i18n";

export default /*#__PURE__*/_defineComponent({
  __name: 'LineChart',
  props: {
  className: {
    type: String,
    default: "chart",
  },
  width: {
    type: String,
    default: "100%",
  },
  height: {
    type: String,
    default: "325px",
  },
  autoResize: {
    type: Boolean,
    default: true,
  },
  detail: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const { t } = useI18n();



onMounted(() => {
  // 获取dom，断言HTMLElement类型，否则会报错
  const chartEle: HTMLElement = document.getElementById("chart") as HTMLElement;
  watch(props, () => {
    showEchart();
  }),
    { immediate: true, deep: true };
  const chart = init(chartEle);
  const showEchart = () => {
    const option: EChartsOption = {
      xAxis: {
        type: "category",
        data: props.detail?.xtime_data,
        axisLine: {
          show: true,
          lineStyle: {
            type: "dashed",
          },
        },
        boundaryGap: false,
        axisTick: {
          show: false,
        },
      },
      grid: {
        left: 40,
        right: 65,
        bottom: 20,
        top: 50,
        containLabel: true,
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
        },
      },
      yAxis: {
        axisTick: {
          show: false,
        },
      },
      legend: {
        data: [t("CPUusagerate"), t("physicalusagerate")],
      },
      series: [
        {
          name: t("CPUusagerate"),
          itemStyle: {
            color: "#7265f9",
          },
          smooth: true,
          type: "line",
          symbol: "none",
          lineStyle: {
            width: 2,
          },
          data: props.detail?.cpu_usage,
          animationDuration: 2800,
          animationEasing: "cubicInOut",
        },
        {
          name: t("physicalusagerate"),
          itemStyle: {
            color: "#ff5636",
          },
          smooth: true,
          type: "line",
          symbol: "none",
          lineStyle: {
            width: 2,
          },
          data: props.detail?.memory_usage,
          animationDuration: 2800,
          animationEasing: "quadraticOut",
        },
      ],
    };
    option && chart.setOption(option);
  };
  showEchart();
  window.addEventListener("resize", () => {
    chart.resize();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "chart",
    class: _normalizeClass(__props.className),
    style: _normalizeStyle({ height: __props.height, width: __props.width })
  }, null, 6))
}
}

})